import { useContext } from 'react';
import { PreloadContext } from '../../../../shared/context/PreloadContext';

export function useIsInvoiceForwardingIntegrationEnabled(): boolean {
	const { isInvoiceForwardingIntegrationEnabled } = useContext(PreloadContext);
	return isInvoiceForwardingIntegrationEnabled;
}
